export const OC_PLUS_MODAL_TRIGGER = 'triggerBuyOcPlusModal'

export const OC_PLUS_LOGO = {
    normal: {
        dark: `<span class="font-serif font-400 text-black">
				Orderchamp<sup class="-top-[0.15rem] font-sans text-[1.15em] text-mustard">+</sup>
			</span>`,
        light: `<span class="font-serif font-400 text-white">
				Orderchamp<sup class="-top-[0.15rem] font-sans text-[1.15em] text-mustard">+</sup>
			</span>`,
    },
    bold: {
        dark: `<span class="font-serif font-700 text-black">
				Orderchamp<sup class="-top-[0.15rem] font-sans text-[1.15em] text-mustard">+</sup>
			</span>`,
        light: `<span class="font-serif font-700 text-white">
				Orderchamp<sup class="-top-[0.15rem] font-sans text-[1.15em] text-mustard">+</sup>
			</span>`,
    },
}
